<template>
    <div class="render-post render-post-linkedin" :class="scrollbarClass" :style="{ fontSize: fontSize + 'px' }" ref="render-post">

        <div class="container-post-content">
            

            <div class="post-content">
                <div class="post-header">
                    
                    <div class="img-pages">

                        <template v-for="(page, index) in visiblePages">
                            <Tooltip
                                :active="page.iconEdited"
                                :key="index"
                                :text="'Voir les modifications apportées'"
                                position="right"
                                :classCustom="`page ${page.iconEdited ? 'iconEdited' : ''}`"
                                @click="() => onClickAvatar(page, index)"
                            >
                                <img :src="page && page.avatar ? page.avatar : 'img/avatar.jpg'" alt="">
                            </Tooltip>
                        </template>

                        <ContextMenu
                            v-if="pages.length > 4"
                            :options="hiddenPagesOptions"
                            id="contextMenuHiddenPagesLinkedin"
                            v-on:clickOption="(_, pageId) => $emit('featurePage', pageId)"
                        >
                            <div class="page count">
                                +{{ pages.length - 3 }}
                            </div>
                        </ContextMenu>
                    </div>

                    <div class="info">
                        <p class="name" v-if="featuredPage" @click="openLinkedinPage(featuredPage)">{{ featuredPage.name }}</p>
                        <div class="date">{{ datePost ? formatDatePost : 'A l\'instant' }} • <i class="fa-solid fa-earth-americas"></i></div>
                    </div>
            
                    <div class="more"><i class="fa-solid fa-ellipsis"></i></div>
                </div>
                <div class="post-text" v-if="text">
                    <p v-html="textTranslate"></p>
                </div>
                

                <div class="survey" v-if="survey">
                    <h5>{{ survey.question }}</h5>
                    <div class="btns">
                        <div class="btn" v-for="(option, index) in survey.options" :key="index">{{ option }}</div>
                    </div>
                    <div class="footer-survey">
                        <p><span class="count">0 vote</span>•<span class="time">{{$t(`dash.postcreator.postLinkedin.survey.${survey.duration}`)}}</span></p>
                    </div>
                </div>
                <div class="snippet" v-else-if="snippet.link">
                    <SnippetNetwork 
                        :link="snippet.link" 
                        :imageUrlDefault="snippet.customActived && snippet.image && snippet.image.id && files[snippet.image.id].isUpload ? files[snippet.image.id].url : undefined" 
                        :titleDefault="snippet.customActived && snippet.title"
                    />
                </div>
                <template v-else-if="medias.find(m => ['pdf'].includes(m.type2))" >
                    <div class="pdf-preview" v-for="media in medias.filter(m => m.type2 == 'pdf').slice(0,1)" :key="media">
                        <div class="navigation-bar">
                            <span class="title">{{ media.info.customName || media.info.name }}</span><span>•</span>{{ pdfPageNumber }} {{ $t('dash.post-creator.render.pdf-pages') }}
                        </div>
                        <pdf  @numpages="(n) => pdfPageNumber = n" :src="media.url" :page="pdfPage"  :key="media.id"></pdf>
                    
                        <div class="previous btn-nav" v-if="pdfPage > 1" @click="()=> pdfPage--"><i class="fa-solid fa-chevron-left"></i></div>
                        <div class="next btn-nav" v-if="pdfPage < pdfPageNumber" @click="()=> pdfPage++"><i class="fa-solid fa-chevron-right"></i></div>
                    </div>
                </template>
                <div 
                    v-else-if="medias.some(m => ['video', 'image'].includes(m.type2))" 
                    :class="[
                        'post-medias media'+ Math.min(medias.length,4), 
                        medias.find(m => ['video', 'image'].includes(m.type2)).aspectRatio > 1 ? 'horizontal' : 'vertical'
                    ]"
                    >
                    
                    <div 
                        v-for="(media,i) in medias.filter(m => ['video', 'image'].includes(m.type2)).slice(0,4)" 
                        class="media" 
                        :key="i"
                        :style="{
                            aspectRatio: i == 0 ? media.aspectRatio : 'auto',
                        }"
                    >
                        <div class="count" v-if="i == 3 && medias.length > 4">+{{ Math.min(medias.length,20) - 3}}</div>
                        
                        <div 
                            v-if="media.type.startsWith('video/')"  
                            class="media-video" 
                            :class="{videoPlayed:videoPlayed}" 
                            @click="togglePlayPause()"
                        >

                            <img v-if="media.imagePreview && !videoPlayed" :src="media.imagePreview.url" alt="" class="imagePreview">
                            <video ref="videoPlayer" playsinline crossorigin="anonymous" preload="metadata" class="video" loop :autoPlay="videoPlayed" :src="media.url" :type="media.type"></video>
                        </div>

                        <img 
                            v-else 
                            :src="media.url" alt=""
                            :style="{
                                aspectRatio: i == 0 ? media.aspectRatio : 'auto',
                            }"
                        >
                    </div>
                
                </div>
                
                <div class="post-empty" v-else-if="!text">

                </div>
           
                <div class="post-footer">

                    <div class="top">
                        <p>{{ comments.length ? '1' : '0' }} commentaires • 0 republication</p>
                    </div>
                    <div class="bottom">
                                             
                        <div class="like">
                            <svg xmlns="http://www.w3.org/2000/svg" height="auto" width="auto" viewBox="0 0 24 24" aria-hidden="true" role="none" data-supported-dps="24x24" fill="currentColor">
                                <path d="M19.46 11l-3.91-3.91a7 7 0 01-1.69-2.74l-.49-1.47A2.76 2.76 0 0010.76 1 2.75 2.75 0 008 3.74v1.12a9.19 9.19 0 00.46 2.85L8.89 9H4.12A2.12 2.12 0 002 11.12a2.16 2.16 0 00.92 1.76A2.11 2.11 0 002 14.62a2.14 2.14 0 001.28 2 2 2 0 00-.28 1 2.12 2.12 0 002 2.12v.14A2.12 2.12 0 007.12 22h7.49a8.08 8.08 0 003.58-.84l.31-.16H21V11zM19 19h-1l-.73.37a6.14 6.14 0 01-2.69.63H7.72a1 1 0 01-1-.72l-.25-.87-.85-.41A1 1 0 015 17l.17-1-.76-.74A1 1 0 014.27 14l.66-1.09-.73-1.1a.49.49 0 01.08-.7.48.48 0 01.34-.11h7.05l-1.31-3.92A7 7 0 0110 4.86V3.75a.77.77 0 01.75-.75.75.75 0 01.71.51L12 5a9 9 0 002.13 3.5l4.5 4.5H19z"></path>
                            </svg>
                            J'aime
                        </div>

                        <div class="comments">
                            <svg xmlns="http://www.w3.org/2000/svg" height="auto" width="auto" viewBox="0 0 24 24" aria-hidden="true" role="none" data-supported-dps="24x24" fill="currentColor">
                                <path d="M7 9h10v1H7zm0 4h7v-1H7zm16-2a6.78 6.78 0 01-2.84 5.61L12 22v-4H8A7 7 0 018 4h8a7 7 0 017 7zm-2 0a5 5 0 00-5-5H8a5 5 0 000 10h6v2.28L19 15a4.79 4.79 0 002-4z"></path>
                            </svg>
                            Commenter
                        </div>
  
                        <div class="share">
                            <svg xmlns="http://www.w3.org/2000/svg" height="auto" width="auto" viewBox="0 0 24 24" aria-hidden="true" role="none" data-supported-dps="24x24" fill="currentColor">
                                <path d="M13.96 5H6c-.55 0-1 .45-1 1v10H3V6c0-1.66 1.34-3 3-3h7.96L12 0h2.37L17 4l-2.63 4H12l1.96-3zm5.54 3H19v10c0 .55-.45 1-1 1h-7.96L12 16H9.63L7 20l2.63 4H12l-1.96-3H18c1.66 0 3-1.34 3-3V8h-1.5z"></path>
                            </svg>
                            Republier
                        </div>
                        <div class="send">
                           <svg xmlns="http://www.w3.org/2000/svg" height="auto" width="auto" viewBox="0 0 24 24" aria-hidden="true" role="none" data-supported-dps="24x24" fill="currentColor">
                                <path d="M21 3L0 10l7.66 4.26L16 8l-6.26 8.34L14 24l7-21z"></path>
                            </svg>
                            Envoyer
                        </div>
                    </div>
                   
                </div>
                      
                <div class="container-comments" v-if="comments && comments.length">
                    <h5>Commentaires</h5>
                    <div class="first-comment" v-for="comment in commentsTranslate">
                        <div class="image-auteur">
                            <img :src="!pages || !pages.length || pages.length > 1 || !pages[0] || !pages[0].avatar ? 'img/avatar.jpg' : pages[0].avatar" alt="">
                        </div>
                        <div class="content-comment">
                            <p class="header-comment">
                                <span class="name">{{ pages.length > 1 ? 'Commentaire' : pages[0].name }}</span>
                                <span class="date">{{ datePost ? formatDatePost : 'A l\'instant' }}</span>
                            </p>
                            <p class="comment" v-html="comment"></p>
                        </div>
                    </div>
                   
        
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SnippetNetwork from './../SnippetNetwork.vue'
    import pdf from 'pdfvuer'
    import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'
    import ContextMenu from '@/components/dash/contextMenu/contextMenuInit.vue'
    import renderPostMixin from '../../../mixins/renderPost';

    export default {
        mixins: [renderPostMixin],
        components: {
            SnippetNetwork,
            pdf,
            Tooltip,
            ContextMenu
        },

        props: {
            files: {
                type: Object,
                default: ()=>({}) 
            },
            pages: {
                type: Array,
                default: ()=>[] 
            },

            datePost: {
                default: '' 
            },
            text : {
                type: String,
                default: ''
            },
            comments : {
                type: Array,
                default: ()=>[]
            },
            medias: {
                type: Array,
                default: ()=>[]
            },
            snippet: {
                type: Object,
                default: ()=>({
                    link : "",
                    title: "",
                    description: "",
                    domaine:"",
                    imageUrl:""
                })
            },
            survey : {
                type: Object,
            },

            mentions: {
                type: Object,
                default: ()=>({})
            }
           
        },
        data() {
            return {
                pdfPageNumber: 1,
                pdfPage:1,
                videoPlayed: false
            }
        },
        methods: {
            loadingPdf() {
                console.log("loadingPdf")
            },
            togglePlayPause(event) {
              
                if (!this.$refs.videoPlayer || !this.$refs.videoPlayer.length) {
                    this.videoPlayed=true
                    return
                }
                const video = this.$refs.videoPlayer[0]
    
                if (video.paused) {
                    video.play();
                    this.videoPlayed=true
                } else {
             
                    video.pause();
                    this.videoPlayed=false
                }
            },

            openLinkedinPage(page) {
                const url = `https://www.linkedin.com/company/${page.network_id}/`;
                window.open(url, '_blank');
            },

            onClickAvatar(page, index) {
                const isTop = index === this.visiblePages.length - 1
                if (!isTop) {
                    this.$emit('featurePage', page.id)
                    return
                }
                page.iconEdited ? this.$emit('clickPage', page.id) : this.openLinkedinPage(page)
            }
        },
        computed: {
            visiblePages() {
                return this.pages.slice(0, this.pages.length == 4 ? 4 : 3)
            },

            featuredPage() {
                return this.visiblePages.length ? this.visiblePages[this.visiblePages.length - 1] : null
            },

            hiddenPagesOptions() {
                return this.pages.slice(this.visiblePages.length).map(page => ({ label: page.name, name: page.id }))
            },

            formatDatePost() {
                let dateMessage = this.datePost
                if (typeof dateMessage !== "object") {
                    dateMessage = new Date(dateMessage)
                }
                let date = new Date()

                if((date.getDate().toString() + date.getMonth().toString() + date.getFullYear().toString()) == (dateMessage.getDate().toString() + dateMessage.getMonth().toString() + dateMessage.getFullYear().toString())){
                    return dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
                    
                }else if((date.getFullYear() == dateMessage.getFullYear()) && (date.getMonth() == dateMessage.getMonth()) && dateMessage.getDate() == (date.getDate() + 1)){
                    return "Demain à "+dateMessage.getHours()+"h"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
                }else{
                    return dateMessage.toLocaleDateString(localStorage.language || undefined, { day: 'numeric', month: 'numeric', year: 'numeric' }) +" à "+dateMessage.getHours()+"h"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes()  ;
                }
            },

            textTranslate() {
                // return this.text
                return this.text.substring(0,3000).replace(/#[\wÀ-ÿ]+/g, '<b class="hashtag">$&</b>').replace(/@(\d{13})/g, (match, id) => {

                    const mention = this.mentions[id];
                    if (mention) {
                        return mention.mention && mention.mention.linkedin ? `<span class="mention">${mention.mention.linkedin.name || mention.mention.linkedin.id}</span>` : mention.textDefault;
                    }
                    return match;
                })
                .replace(
                    /https?:\/\/[^\s\n]+[^.\s\n]/g, 
                    (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
                )
                .replace(/\n/g, '<br>');
          
              
            },

            commentsTranslate() {
                return this.comments.map(comment => (
                    comment.replace(/#[\wÀ-ÿ]+/g, '<b class="hashtag">$&</b>').replace(/@(\d{13})/g, (match, id) => {
                        const mention = this.mentions[id];
                        if (mention) {
                            return mention.mention && mention.mention.linkedin ? `<span class="mention">${mention.mention.linkedin.name || mention.mention.linkedin.id}</span>` : mention.textDefault;
                        }
                        return match;
                    })
                    .replace(/\n/g, '<br>')
                    .replace(
                        /https?:\/\/[^<\s]+(?=<br>|\s|$)/g, // S'arrête avant <br>, espace ou fin de chaîne
                        (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
                    )
                ))
            }
           
        },

       watch: {
        medias(newValue, oldValue) {
            if(newValue && oldValue && newValue.length && newValue.filter(m => m.type2 == 'pdf')?.[0]?.id !== oldValue.filter(m => m.type2 == 'pdf')?.[0]?.id) {
                this.pdfPage = 1
            }
        }
       },
    }
</script>
